module.exports = __webpack_public_path__ + "static/assets/71451233518e248c48c49aab303d6c00.png";